import { useKeepAwake } from 'expo-keep-awake';
import { Stack, useLocalSearchParams, useRouter } from 'expo-router';
import { View } from 'react-native';
import { Display, mq, StyleSheet } from 'react-native-unistyles';
import EventScorekeepingFeed from '@/components/Event/EventScorekeeping/EventScorekeepingFeed';
import EventScorekeepingFeedItem, {
  Card,
} from '@/components/Event/EventScorekeeping/EventScorekeepingFeed/EventScorekeepingFeedItem';
import Box from '@/components/UI/Box';
import Pressable from '@/components/Unistyles/Pressable';
import EventScorekeepingPanel from './components/EventScorekeepingPanel';

export default function EventScorekeepingEdit({
  basePath,
}: {
  basePath: string;
}) {
  useKeepAwake();
  const { setParams } = useRouter();
  const { badgeAssigneeId } = useLocalSearchParams<{
    eventId: string;
    badgeAssigneeId: string;
  }>();

  return (
    <View style={style.container}>
      <Stack.Screen
        options={{
          title: 'Scorekeeper Mode',
        }}
      />
      <EventScorekeepingPanel basePath={basePath} />
      <Display mq={mq.only.width('lg')}>
        <Box style={style.feed}>
          <EventScorekeepingFeed
            extraData={badgeAssigneeId}
            renderItem={({ item }) => {
              const variant = badgeAssigneeId === item.id ? 'info' : undefined;

              return (
                <Card variant={variant}>
                  <Pressable
                    accessibilityLabel="Scorekeeping assignment"
                    onPress={() => {
                      setParams({
                        badgeAssigneeId: item.id,
                      });
                    }}
                    testID={`ScorekeepingFeedItem-${item.id}`}
                  >
                    <EventScorekeepingFeedItem
                      variant={variant}
                      fragment={item.badge_assignees}
                    />
                  </Pressable>
                </Card>
              );
            }}
          />
        </Box>
      </Display>
    </View>
  );
}

const style = StyleSheet.create((theme) => ({
  container: {
    flex: 1,
    flexDirection: 'row',
  },
  feed: {
    height: '100%',
    flex: {
      base: 1,
      lg: 2,
    },
    maxWidth: theme.size(128),
  },
}));
